export const filter_config = (audience_options = [], tag_options = []) => {
  return {
    title: 'Contact filters',
    filters: [
      {
        label: 'Valid',
        key: 'is_valid',
        value: 'is_valid',
        type: 'boolean'
      },
      {
        label: 'Audiences',
        key: 'subscriptions',
        value: audience_options,
        type: 'multichoice'
      },
      {
        label: 'Tags',
        key: 'tags',
        value: tag_options,
        type: 'multichoice'
      },
      { value: 'created_on', label: 'Date created', key: 'created_on', type: 'range' }
    ]
  };
};
